export default [
  {
    id: 1,
    title: { it: "Boiserie", en: "Wall panelling" },
    subTitle: {
      it: "boiserie Arnad",
      en: "Arnad wall panelling",
    },
    products: [
      {
        sourceImage: require("./images/mainImgs/home/01c.jpg"),
        detailImage: "ArnadHome",
        room: "Home",
        code: "01c",
        name: { it: "Ingresso", en: "Entrance" },
        size: {
          height: "36,3 - 75-2 - 91,5 - 109,8",
          widths: "60 - 90 - 120",
          depths: "2,9",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/05a.jpg"),

        detailImage: "ArnadHome",
        room: "Home",
        code: "05a",
        name: { it: "Soggiorno", en: "Living room" },
        size: {
          height: "36,3 - 75-2 - 91,5 - 109,8",
          widths: "60 - 90 - 120",
          depths: "2,9",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/08a.jpg"),

        detailImage: "ArnadHome",
        room: "Home",
        code: "08a",
        name: { it: "Camera", en: "Bedroom" },
        size: {
          height: "36,3 - 75-2 - 91,5 - 109,8",
          widths: "60 - 90 - 120",
          depths: "2,9",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/11c.jpg"),

        detailImage: "ArnadHome",
        room: "Home",
        code: "11c",
        name: { it: "Camera", en: "Bedroom" },
        size: {
          height: "36,3 - 75-2 - 91,5 - 109,8",
          widths: "60 - 90 - 120",
          depths: "2,9",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/01a.jpg"),

        detailImage: "ArnadPublic",
        room: "Public",
        code: "01a",
        name: { it: "Direzionale", en: "Executive space" },
        size: {
          height: "36,3 - 75-2 - 91,5 - 109,8",
          widths: "60 - 90 - 120",
          depths: "2,9",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/07b.jpg"),

        detailImage: "ArnadPublic",
        room: "Public",
        code: "07b",
        name: { it: "Spazi comuni", en: "Common areas" },
        size: {
          height: "36,3 - 75-2 - 91,5 - 109,8",
          widths: "60 - 90 - 120",
          depths: "2,9",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/10b.jpg"),

        detailImage: "ArnadPublic",
        room: "Public",
        code: "10b",
        name: { it: "Camera hotel", en: "Hotel room" },
        size: {
          height: "36,3 - 75-2 - 91,5 - 109,8",
          widths: "60 - 90 - 120",
          depths: "2,9",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/12a.jpg"),

        detailImage: "ArnadPublic",
        room: "Public",
        code: "12a",
        name: { it: "Direzionale", en: "Executive space" },
        size: {
          height: "36,3 - 75-2 - 91,5 - 109,8",
          widths: "60 - 90 - 120",
          depths: "2,9",
        },
      },
    ],
  },
  {
    id: 2,
    title: { it: "Boiserie", en: "Wall panelling" },
    subTitle: { it: "boiserie Cover", en: "Cover wall panelling" },
    products: [
      {
        sourceImage: require("./images/mainImgs/home/03b.jpg"),
        detailImage: "CoverHome",
        room: "Home",
        code: "03b",
        name: { it: "Ingresso", en: "Entrance" },
        size: {
          height:
            "111,5 - 129,8 - 148,1 - 202,3 - 221,3 - 239,6 - 257,9 - 294,5",
          widths: "45 - 60 - 90 - 120",
          depths: "3,3",
        },
      },
      {
        sourceImage: require("./images/mainImgs/home/04b.jpg"),

        detailImage: "CoverHome",
        room: "Home",
        code: "04b",
        name: { it: "Soggiorno", en: "Living room" },
        size: {
          height:
            "111,5 - 129,8 - 148,1 - 202,3 - 221,3 - 239,6 - 257,9 - 294,5",
          widths: "45 - 60 - 90 - 120",
          depths: "3,3",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/10b.jpg"),

        detailImage: "CoverHome",
        room: "Home",
        code: "10b",
        name: { it: "Camera", en: "Bedroom" },
        size: {
          height:
            "111,5 - 129,8 - 148,1 - 202,3 - 221,3 - 239,6 - 257,9 - 294,5",
          widths: "45 - 60 - 90 - 120",
          depths: "3,3",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/02b.jpg"),

        detailImage: "CoverPublic",
        room: "Public",
        code: "02b",
        name: { it: "Direzionale", en: "Executive space" },
        size: {
          height:
            "111,5 - 129,8 - 148,1 - 202,3 - 221,3 - 239,6 - 257,9 - 294,5",
          widths: "45 - 60 - 90 - 120",
          depths: "3,3",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/03c.jpg"),

        detailImage: "CoverPublic",
        room: "Public",
        code: "03c",
        name: { it: "Operativo", en: "Workspace" },
        size: {
          height:
            "111,5 - 129,8 - 148,1 - 202,3 - 221,3 - 239,6 - 257,9 - 294,5",
          widths: "45 - 60 - 90 - 120",
          depths: "3,3",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/11c.jpg"),

        detailImage: "CoverPublic",
        room: "Public",
        code: "11c",
        name: { it: "Camera hotel", en: "Hotel room" },
        size: {
          height:
            "111,5 - 129,8 - 148,1 - 202,3 - 221,3 - 239,6 - 257,9 - 294,5",
          widths: "45 - 60 - 90 - 120",
          depths: "3,3",
        },
      },
      {
        sourceImage: require("./images/mainImgs/public/15b.jpg"),

        detailImage: "CoverPublic",
        room: "Public",
        code: "15b",
        name: { it: "Negozio", en: "Store" },
        size: {
          height:
            "111,5 - 129,8 - 148,1 - 202,3 - 221,3 - 239,6 - 257,9 - 294,5",
          widths: "45 - 60 - 90 - 120",
          depths: "3,3",
        },
      },
    ],
  },
];
